import { LEGAL, isSet } from "@/lib/legal";
import { Rich } from "@/components/info/DocRenderer";

const Value = ({ v, mail }) => (isSet(v) && mail
  ? <a href={`mailto:${v}`} className="font-medium text-amber-600 hover:underline dark:text-amber-400">{v}</a>
  : <Rich text={v} />);

const ROWS = [
  ["Utilisation, accès, droits dans votre entreprise", "Contactez d'abord l'administrateur de votre Workplace : il gère les comptes, rôles, sites et référentiels.", null],
  ["Contact général, offre, DPA", "Questions sur le service, demande du DPA ou des conditions commerciales.", LEGAL.contactEmail],
  ["Données personnelles", "Exercice de vos droits sur la gestion du service (voir [Confidentialité](/infos/confidentialite)).", LEGAL.privacyEmail],
  ["Sécurité", "Signalement d'une vulnérabilité (voir [Signalement de vulnérabilité](/infos/signalement-vulnerabilite)).", LEGAL.securityEmail],
];

export const ContactInfo = () => (
  <div className="space-y-6">
    <p className="text-base text-muted-foreground">Choisissez le bon interlocuteur selon votre demande. Aucun formulaire n'est proposé : écrivez directement aux adresses ci-dessous dès qu'elles sont publiées.</p>
    <div className="grid gap-4 sm:grid-cols-2">
      {ROWS.map(([title, desc, email], i) => (
        <div key={title} data-testid={`contact-card-${i}`} className="rounded-lg border border-border bg-card p-4">
          <p className="font-semibold">{title}</p>
          <p className="mt-1 text-sm text-muted-foreground"><Rich text={desc} /></p>
          {email && <p className="mt-3 text-sm">E-mail : <Value v={email} mail /></p>}
        </div>
      ))}
    </div>
    <div className="rounded-lg border border-border p-4 text-sm" data-testid="contact-phone">
      Téléphone : <Value v={LEGAL.phone} /> · {LEGAL.serviceName} — écosystème {LEGAL.brand}, {LEGAL.territory}
    </div>
    <p className="text-sm text-muted-foreground">Ne transmettez jamais votre mot de passe ni de données réelles inutiles (photos, Take 5) dans un message.</p>
  </div>
);
